module.exports = __webpack_public_path__ + "bed-rules.9d03f9df.png";